<template>
  <div
    :class="{
      toggle: true,
      toggleBackgraund: variant === 'backgraund'
    }"
  >
    <div class="toggle__content">
      <input
        :id="name"
        :name="name"
        class="offscreen"
        type="checkbox"
        :disabled="disabled"
        :checked="value"
        :value="value"
      />
      <label
        :for="name"
        :class="{ switch: true, switch_disabled: disabled }"
      ></label>
    </div>
    <div class="toggle__title">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Toggle',
  props: ['title', 'variant', 'name', 'value', 'disabled']
})
export default class ToggleComponent extends Vue {}
</script>

<style lang="scss" scoped>
.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .toggle__content {
    background-color: $white;
  }
  .toggle__title {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 400;
    margin-left: 10px;
    p {
      background-color: $white;
    }
  }
}

.toggleBackgraund {
  background-color: $light-grey;
  .toggle__content {
    background-color: $light-grey;
  }
  .toggle__title {
    margin-left: 10px;
    margin-right: 17px;
    p {
      background-color: $light-grey;
    }
  }
}

.switch {
  position: relative;
  display: inline-block;
  align-items: center;
  background-color: #e0e0e0;
  width: 32px;
  height: 10px;
  border-radius: 5px;
  transition: all 0.3s;
  cursor: pointer;
}

.switch_disabled {
  cursor: default;
}

.switch::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 18px;
  background-color: #c0c0c0;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
  top: -3px;
  left: 0;
  transition: all 0.3s;
  cursor: pointer;
}

.switch_disabled::after {
  cursor: default;
}

input:checked + .switch::after {
  transform: translateX(20px);
  background-color: #47987f;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
}

input:checked + .switch {
  background-color: rgba(71, 152, 127, 0.18);
}

.offscreen {
  position: absolute;
  left: -9999px;
}
</style>
